import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../../firebase";

const BANCO_EMOJIS = [
  {
    categoria: "Mundial / Deportes",
    emojis: ["⚽", "🏆", "🥅", "🎉", "🇲🇽", "🥳"],
  },
  {
    categoria: "Año Nuevo",
    emojis: ["🎆", "🥂", "🎉", "✨", "🥳"],
  },
  {
    categoria: "Amor / San Valentín",
    emojis: ["❤️", "💕", "💘", "🌹", "🥂", "💌"],
  },
  {
    categoria: "Navidad",
    emojis: ["🎄", "🎁", "⭐", "❄️", "⛄", "🦌"],
  },
  {
    categoria: "Día de la Madre",
    emojis: ["🌸", "💐", "❤️", "👩‍👧", "👩‍👦", "🫂"],
  },
  {
    categoria: "Día del Padre",
    emojis: ["👨‍👧", "👨‍👦", "🧔", "🥸", "💙", "🍻"],
  },
  {
    categoria: "Fiestas Patrias",
    emojis: ["🇲🇽", "🎉", "🌮", "🎺", "🧔", "🔥"],
  },
  {
    categoria: "Día de Muertos",
    emojis: ["💀", "🕯️", "🌼", "🏵️", "🍬", "🧡"],
  },
  {
    categoria: "Halloween",
    emojis: ["🎃", "👻", "🦇", "🧙‍♀️", "🕷️", "🧟"],
  },
  {
    categoria: "Primavera / Flores",
    emojis: ["🌸", "🌺", "🌻", "🌷", "🦋", "☀️"],
  },
  {
    categoria: "Celebración general",
    emojis: ["🎉", "🎊", "🥳", "✨", "🔥", "👏"],
  },
];

function AdminDecoraciones() {
  const [decoraciones, setDecoraciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [nombre, setNombre] = useState("");
  const [elementosTexto, setElementosTexto] = useState("⚽");
  const [cantidad, setCantidad] = useState("8");
  const [tamanoPx, setTamanoPx] = useState("28");
  const [movimiento, setMovimiento] = useState("flotar");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [duracionSegundos, setDuracionSegundos] = useState("0");
  const [activo, setActivo] = useState(true);
  const [mostrarBancoEmojis, setMostrarBancoEmojis] = useState(false);

  const cargarDecoraciones = async () => {
    setCargando(true);
    setMensaje("");

    try {
      const decoracionesRef = collection(db, "decoraciones");
      const q = query(decoracionesRef, orderBy("fechaCreacion", "desc"));
      const snapshot = await getDocs(q);

      const lista = snapshot.docs.map((documento) => ({
        id: documento.id,
        ...documento.data(),
      }));

      setDecoraciones(lista);
    } catch (error) {
      console.error("Error cargando decoraciones:", error);
      setMensaje("❌ No se pudieron cargar las decoraciones.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarDecoraciones();
  }, []);

  const limpiarFormulario = () => {
    setNombre("");
    setElementosTexto("⚽");
    setCantidad("8");
    setTamanoPx("28");
    setMovimiento("flotar");
    setFechaInicio("");
    setFechaFin("");
    setDuracionSegundos("0");
    setActivo(true);
    setMostrarBancoEmojis(false);
  };

  const obtenerElementos = () => {
    return elementosTexto
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const agregarEmojiBanco = (emoji) => {
    const actuales = obtenerElementos();

    if (actuales.includes(emoji)) return;

    const nuevos = [...actuales, emoji];

    setElementosTexto(nuevos.join(", "));
  };

  const handleGuardarDecoracion = async (e) => {
    e.preventDefault();

    const elementos = obtenerElementos();

    if (!nombre.trim()) {
      setMensaje("⚠️ Ingresa un nombre para la decoración.");
      return;
    }

    if (elementos.length === 0) {
      setMensaje("⚠️ Selecciona o escribe al menos un emoji.");
      return;
    }

    if (!fechaInicio || !fechaFin) {
      setMensaje("⚠️ Selecciona fecha de inicio y fecha de fin.");
      return;
    }

    setGuardando(true);
    setMensaje("");

    try {
      await addDoc(collection(db, "decoraciones"), {
        nombre: nombre.trim(),
        tipo: "emoji",

        // Compatibilidad con decoraciones anteriores
        elemento: elementos[0],

        // Nuevo formato con varios emojis
        elementos,

        cantidad: Number(cantidad || 1),
        tamanoPx: Number(tamanoPx || 24),
        movimiento,
        fechaInicio,
        fechaFin,
        duracionSegundos: Number(duracionSegundos || 0),
        activo,
        fechaCreacion: new Date().toISOString(),
      });

      setMensaje("✅ Decoración guardada correctamente.");
      limpiarFormulario();
      cargarDecoraciones();
    } catch (error) {
      console.error("Error guardando decoración:", error);
      setMensaje("❌ No se pudo guardar la decoración.");
    } finally {
      setGuardando(false);
    }
  };

  const handleToggleActivo = async (decoracion) => {
    try {
      await updateDoc(doc(db, "decoraciones", decoracion.id), {
        activo: !decoracion.activo,
      });

      setMensaje(
        decoracion.activo
          ? "⚙️ Decoración desactivada."
          : "✅ Decoración activada.",
      );

      cargarDecoraciones();
    } catch (error) {
      console.error("Error cambiando decoración:", error);
      setMensaje("❌ No se pudo actualizar la decoración.");
    }
  };

  const handleEliminarDecoracion = async (decoracionId) => {
    const confirmar = window.confirm(
      "¿Seguro que deseas eliminar esta decoración?",
    );

    if (!confirmar) return;

    try {
      await deleteDoc(doc(db, "decoraciones", decoracionId));

      setMensaje("⚙️ Decoración eliminada.");
      cargarDecoraciones();
    } catch (error) {
      console.error("Error eliminando decoración:", error);
      setMensaje("❌ No se pudo eliminar la decoración.");
    }
  };

  const mostrarElementosDecoracion = (decoracion) => {
    if (decoracion.elementos && Array.isArray(decoracion.elementos)) {
      return decoracion.elementos.join(" ");
    }

    return decoracion.elemento || "🎉";
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #eee",
          borderRadius: "16px",
          padding: "20px",
          marginBottom: "18px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        }}
      >
        <h2
          style={{
            margin: "0 0 8px 0",
            fontSize: "22px",
            fontWeight: "900",
          }}
        >
          🎉 Decoraciones y eventos
        </h2>

        <p
          style={{
            margin: "0 0 16px 0",
            color: "#666",
            fontSize: "14px",
            lineHeight: "1.5",
          }}
        >
          Programa animaciones ligeras para eventos especiales. Puedes usar uno
          o varios emojis por decoración.
        </p>

        {mensaje && (
          <div
            style={{
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "16px",
              fontSize: "14px",
              fontWeight: "700",
              backgroundColor:
                mensaje.includes("✅") || mensaje.includes("⚙️")
                  ? "#e6f4ea"
                  : "#fce8e6",
              color:
                mensaje.includes("✅") || mensaje.includes("⚙️")
                  ? "#137333"
                  : "#c5221f",
            }}
          >
            {mensaje}
          </div>
        )}

        <form
          onSubmit={handleGuardarDecoracion}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "12px",
          }}
        >
          <div>
            <label style={labelStyle}>Nombre del evento</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Mundial, Navidad, San Valentín..."
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Emojis seleccionados</label>
            <input
              type="text"
              value={elementosTexto}
              onChange={(e) => setElementosTexto(e.target.value)}
              placeholder="⚽, 🏆, 🎉"
              style={inputStyle}
            />
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginTop: "4px",
                lineHeight: "1.4",
              }}
            >
              Puedes escribir varios separados por coma. Ejemplo:{" "}
              <strong>⚽, 🏆, 🎉</strong>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#f8f8f8",
              border: "1px solid #eee",
              borderRadius: "14px",
              padding: "12px",
            }}
          >
            <button
              type="button"
              onClick={() => setMostrarBancoEmojis(!mostrarBancoEmojis)}
              style={{
                width: "100%",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "10px 12px",
                fontSize: "14px",
                fontWeight: "900",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Banco rápido de emojis</span>
              <span>{mostrarBancoEmojis ? "▲ Ocultar" : "▼ Mostrar"}</span>
            </button>

            {mostrarBancoEmojis && (
              <div
                style={{
                  display: "grid",
                  gap: "12px",
                  marginTop: "12px",
                }}
              >
                {BANCO_EMOJIS.map((grupo) => (
                  <div key={grupo.categoria}>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#555",
                        marginBottom: "6px",
                      }}
                    >
                      {grupo.categoria}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      {grupo.emojis.map((emoji) => (
                        <button
                          key={`${grupo.categoria}-${emoji}`}
                          type="button"
                          onClick={() => agregarEmojiBanco(emoji)}
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "10px",
                            border: "1px solid #ddd",
                            backgroundColor: "#fff",
                            fontSize: "19px",
                            cursor: "pointer",
                          }}
                          title={`Agregar ${emoji}`}
                        >
                          {emoji}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <label style={labelStyle}>Movimiento</label>
            <select
              value={movimiento}
              onChange={(e) => setMovimiento(e.target.value)}
              style={inputStyle}
            >
              <option value="flotar">Flotar suave</option>
              <option value="caer">Caer desde arriba</option>
              <option value="rebotar">Rebotar</option>
            </select>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div>
              <label style={labelStyle}>Cantidad total en pantalla</label>
              <input
                type="number"
                value={cantidad}
                onChange={(e) => setCantidad(e.target.value)}
                min="1"
                max="30"
                style={inputStyle}
              />
            </div>

            <div>
              <label style={labelStyle}>Tamaño px</label>
              <input
                type="number"
                value={tamanoPx}
                onChange={(e) => setTamanoPx(e.target.value)}
                min="12"
                max="90"
                style={inputStyle}
              />
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div>
              <label style={labelStyle}>Fecha inicio</label>
              <input
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div>
              <label style={labelStyle}>Fecha fin</label>
              <input
                type="date"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
                style={inputStyle}
              />
            </div>
          </div>

          <div>
            <label style={labelStyle}>Duración al abrir tienda</label>
            <input
              type="number"
              value={duracionSegundos}
              onChange={(e) => setDuracionSegundos(e.target.value)}
              min="0"
              style={inputStyle}
            />
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginTop: "4px",
                lineHeight: "1.4",
              }}
            >
              Usa <strong>0</strong> para que permanezca visible mientras esté
              dentro de las fechas. Usa, por ejemplo, <strong>10</strong> para
              mostrarlo solo 10 segundos.
            </div>
          </div>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "13px",
              fontWeight: "800",
            }}
          >
            <input
              type="checkbox"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
            Decoración activa
          </label>

          <button
            type="submit"
            disabled={guardando}
            style={{
              backgroundColor: guardando ? "#777" : "#111",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px",
              fontSize: "15px",
              fontWeight: "900",
              cursor: guardando ? "not-allowed" : "pointer",
            }}
          >
            {guardando ? "Guardando..." : "Guardar decoración"}
          </button>
        </form>
      </div>

      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #eee",
          borderRadius: "16px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        }}
      >
        <h3
          style={{
            margin: "0 0 12px 0",
            fontSize: "18px",
            fontWeight: "900",
          }}
        >
          Decoraciones registradas
        </h3>

        {cargando ? (
          <p style={{ fontWeight: "700" }}>Cargando decoraciones...</p>
        ) : decoraciones.length === 0 ? (
          <p style={{ color: "#777", fontSize: "14px" }}>
            Todavía no hay decoraciones registradas.
          </p>
        ) : (
          <div
            style={{
              display: "grid",
              gap: "10px",
            }}
          >
            {decoraciones.map((decoracion) => (
              <div
                key={decoracion.id}
                style={{
                  border: "1px solid #eee",
                  borderRadius: "14px",
                  padding: "14px",
                  backgroundColor: decoracion.activo ? "#f8fff9" : "#f8f8f8",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: "17px",
                        fontWeight: "900",
                        marginBottom: "4px",
                      }}
                    >
                      {mostrarElementosDecoracion(decoracion)}{" "}
                      {decoracion.nombre}
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        lineHeight: "1.5",
                      }}
                    >
                      {decoracion.fechaInicio} → {decoracion.fechaFin}
                      <br />
                      Movimiento: {decoracion.movimiento} · Cantidad:{" "}
                      {decoracion.cantidad} · Tamaño: {decoracion.tamanoPx}px
                      <br />
                      Duración:{" "}
                      {Number(decoracion.duracionSegundos || 0) === 0
                        ? "Permanente"
                        : `${decoracion.duracionSegundos} segundos`}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => handleToggleActivo(decoracion)}
                      style={{
                        backgroundColor: decoracion.activo
                          ? "#fbbc04"
                          : "#137333",
                        color: "#111",
                        border: "none",
                        borderRadius: "8px",
                        padding: "7px 10px",
                        fontSize: "12px",
                        fontWeight: "900",
                        cursor: "pointer",
                      }}
                    >
                      {decoracion.activo ? "Pausar" : "Activar"}
                    </button>

                    <button
                      type="button"
                      onClick={() => handleEliminarDecoracion(decoracion.id)}
                      style={{
                        backgroundColor: "#c5221f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "7px 10px",
                        fontSize: "12px",
                        fontWeight: "900",
                        cursor: "pointer",
                      }}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "800",
  marginBottom: "5px",
  color: "#333",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default AdminDecoraciones;
